import styled from "styled-components";
import {JackpotAmountDefaultBox} from "./jackpot-amount.default.box";

export const JackpotAmountSiBox = styled(JackpotAmountDefaultBox)`
    font-size: ${props => props.theme.font.size.small};
    font-weight: 400;
`